import React from 'react';
import PropTypes from 'prop-types';
import useBillDetailsStyles from './billDetailsStyles';

/**
 * A part of the bill details panel, named above its cards (LB-6099): the accounts payable side -- what goes to
 * AppFolio -- and the allocation side look alike, card for card, and people edited one while meaning the other.
 * Larger than a card's title, and a real heading, so the panel reads as two parts.
 */
export const SectionHeading = _ref => {
  let title = _ref.title,
    caption = _ref.caption;
  const classes = useBillDetailsStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.dataContentBlock, " ").concat(classes.sectionHeading)
  }, /*#__PURE__*/React.createElement("h3", {
    className: classes.sectionHeadingTitle
  }, title), caption ? /*#__PURE__*/React.createElement("p", {
    className: classes.sectionHeadingCaption
  }, caption) : null);
};
SectionHeading.propTypes = {
  caption: PropTypes.node,
  title: PropTypes.string.isRequired
};